import { render, staticRenderFns } from "./TagEditorModal.vue?vue&type=template&id=8cf38d2a"
import script from "./TagEditorModal.vue?vue&type=script&lang=ts"
export * from "./TagEditorModal.vue?vue&type=script&lang=ts"
import style0 from "./TagEditorModal.vue?vue&type=style&index=0&id=8cf38d2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports